import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'

const MasterLayout = () => {
  const location = useLocation()

  useEffect(() => {
    // Use requestAnimationFrame for better timing - runs after DOM updates but before next paint
    // This is much faster than setTimeout(500ms) and ensures menu reinitializes after DOM is ready
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        MenuComponent.reinitialization()
      })
    })
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet key={location.key || (location.pathname + location.search) || 'default'} />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>


      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
